/** V80 / 达克公共常量 — 型号表见 dakaiModels.ts */
export {
  V80_DRV_SN,
  V80_MATRIX_DATA_LENGTH,
  V80_MATRIX_KEY_COUNT,
  V80_MATRIX_COLUMNS,
  V80_FN_BLOCKED_POSITIONS,
  V80_FN_DEFAULT_EMPTY_POSITIONS,
  DAKAI_MATRIX_COLUMNS,
  V102_LOGO_DRV_SN,
  V102_SMG_DRV_SN,
  V102_MATRIX_DATA_LENGTH,
  V102_MATRIX_KEY_COUNT,
  V102_FN_BLOCKED_POSITIONS,
  DAKAI_MODEL_SPECS,
  resolveDakaiModelSpec,
  isSupportedDakaiDrvSN,
  type DakaiModelId,
  type DakaiModelSpec,
} from "./dakaiModels";

export const DAKAI_SHORTCUT_ROW_STANDARD = 0x08;
export const DAKAI_SHORTCUT_ROW_FN = 0x09;
export const DAKAI_SHORTCUT_DATA_LENGTH = 0x25;
export const DAKAI_SHORTCUT_MAX = 12;

export const DAKAI_SUPPORTED_USAGES: ReadonlyArray<{
  usagePage: number;
  usage: number;
}> = [
  { usagePage: 0x00c0, usage: 0x0001 },
  { usagePage: 0x008c, usage: 0x0006 },
  { usagePage: 0xff00, usage: 0x000e },
];

/** USB 灯效模式（与 DK-Test.html `#lightingEffect` 一致，值 = usbLightingSet） */
export const DAKAI_V80_LIGHTING_MODES: ReadonlyArray<{
  value: number;
  label: string;
  group: "dynamic" | "static";
}> = [
  { value: 0x00, label: "呼吸", group: "dynamic" },
  { value: 0x01, label: "幻彩", group: "dynamic" },
  { value: 0x02, label: "跑马", group: "dynamic" },
  { value: 0x03, label: "潮汐", group: "dynamic" },
  { value: 0x04, label: "七彩流光", group: "dynamic" },
  { value: 0x05, label: "涟漪", group: "dynamic" },
  { value: 0x06, label: "三色卡通", group: "dynamic" },
  { value: 0x07, label: "碰撞", group: "dynamic" },
  { value: 0x10, label: "常亮 · 红色", group: "static" },
  { value: 0x11, label: "常亮 · 橙色", group: "static" },
  { value: 0x12, label: "常亮 · 黄色", group: "static" },
  { value: 0x13, label: "常亮 · 绿色", group: "static" },
  { value: 0x14, label: "常亮 · 青色", group: "static" },
  { value: 0x15, label: "常亮 · 蓝色", group: "static" },
  { value: 0x16, label: "常亮 · 紫色", group: "static" },
  { value: 0x17, label: "常亮 · 白色", group: "static" },
  { value: 0x18, label: "常亮 · 混彩", group: "static" },
];

export function isDakaiV80StaticLightingMode(mode: number): boolean {
  return mode >= 0x10 && mode <= 0x18;
}

export function isDakaiV80DynamicLightingMode(mode: number): boolean {
  return mode >= 0x00 && mode <= 0x07;
}
